import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  artworkClausesOptions,
  RemixClausesOptions,
} from "shared/components/AllDropdownOptions";
import {
  CustomAmountDropdown,
  CustomAmountInput,
  CustomCalendar,
  CustomCheckbox,
  CustomInput,
  CustomNumberInput,
  CustomTextArea,
} from "shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import formValidation from "utils/validations";

const ArtWork = ({ data, setData, onArtworkSubmit }) => {
  const {id} = useParams()

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleCurrencyChange = (newCurrencySymbol) => {
    setData((prev) => ({
      ...prev,
      currencySymbol: newCurrencySymbol,
    }));
  };

  return (
    <>
      <div className="w-6">
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          label="Name of Agreement"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-top">
          <div className="flex w-full ">
            <CustomInput
              name="fullLegalName"
              data={data}
              col={5}
              onChange={handleChange}
              label="Artist Full Legal Name"
            />
            <div className="col text-center h-full flex justify-content-center align-items-center">
              p/k/a
            </div>
            <CustomInput
              data={data}
              label="Artist Name"
              col={5}
              name="name"
              onChange={handleChange}
            />
          </div>

          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <label className="text-gray-500 mb-0" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              col={12}
              className="w-full "
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <CustomInput
            name="artworkCreatorName"
            data={data}
            label="Artwork Creater Full Legal Name"
            col={6}
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full "
            rows={5}
            cols={30}
            data={data}
            label="Artwork Creator Address"
            name="artworkCreatorAddress"
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            label="Music Release Name"
            col={6}
            name="musicRelaseName"
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full "
            rows={5}
            cols={30}
            data={data}
            label="Describe the artwork to be created"
            name="artWorkDescription"
            onChange={handleChange}
          />
          <CustomAmountDropdown
            name="artworkFee"
            label="Payment Amount"
            data={data}
            currencyCode={data.currency}
            onCurrencyChange={handleCurrencyChange}
            onChange={handleChange}
          />
          <CustomTextArea
            col={12}
            className="w-full"
            rows={5}
            cols={30}
            data={data}
            placeholder="Payment terms, e.g., 50% upon signing this Agreement and 50% upon completion of the Artwork."
            label="Payment Structure"
            name="paymentStructure"
            onChange={handleChange}
          />
          <CustomCalendar
            label="Delivery Date"
            col={6}
            name="deliveryDate"
            value={data?.deliveryDate ? new Date(data.deliveryDate) : null}
            data={data}
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            name="deliveryFormat"
            col={6}
            onChange={handleChange}
            placeholder="Specify formats, e.g., JPEG, PNG, PSD"
            label="Delivery Specs"
          />

          <div className="md:col-12 mb-3">
            <h5 className="text-xl font-medium mb-3">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-3">
              Add any clauses that may be needed for your contract.
            </p>
            <div className="">
              <p className="mt-2 text-lg font-light mb-3 ">
                1.COPYRIGHT AND OWNERSHIP
              </p>
              <p className="text-lg font-normal">
                Work-for-hire but the Creator may display the Artwork in their
                portfolio for self-promotion purposes
              </p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="copyright"
                checked={true}
                disabled
              />
            </div>
            <div className="">
              <p className="mt-2 text-lg font-light mb-1 ">2.REVISIONS</p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="revisions"
                checked={true}
                disabled
              />
              <div className="flex align-item-center">
                <CustomNumberInput
                  data={data}
                  label="Rounds of Revision"
                  placeholder="Number of rounds you and the Creator agree to revise"
                  name="revisonRound"
                  onChange={handleChange}
                />
                <CustomAmountDropdown
                  data={data}
                  label="Fee for Additional Revision"
                  name="additionalCharges"
                  currencyCode={data.currency}
                  onCurrencyChange={handleCurrencyChange}
                  onChange={handleChange}
                  col={6}
                />
              </div>
            </div>
            <div className="">
              <p className="mt-2 text-lg font-light mb-3 ">
                3.WARRANTIES AND REPRESENTATIONS
              </p>
              <p className="text-lg font-normal">
                The Creator warrants the artwork created is original and does
                not infringe upon any third-parties' rights.
              </p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="warrantiesandrepresentations"
                checked={true}
                disabled
              />
              <CustomTextArea
                data={data}
                placeholder="Any other comments"
                name="warrenties"
                onChange={handleChange}
                ignoreLabel
              />
            </div>
            <div className="">
              <p className="mt-2 text-lg font-light mb-1 ">4.TERMINATION </p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="terminations"
                checked={true}
                disabled
              />
              <CustomInput
                data={data}
                label="Days allowed to cure the breach"
                name="days"
                col={12}
                placeholder="In the event of breach of the agreement, upon notice, the party shall have how long to cure the breach. e.g. 30 days"
                onChange={handleChange}
              />
            </div>
            <div className="">
              <p className="mt-2 text-lg font-light mb-1 ">5.GOVERNING LAW </p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="governingLaw"
                checked={true}
                disabled
              />
              <CustomInput
                data={data}
                col={12}
                label="Jurisdiction"
                name="law"
                placeholder="Enter the jurisdiction governing the contract. e.g. Singapore, Hong Kong SAR, State of California"
                onChange={handleChange}
              />
            </div>
            <div className="">
              <p className="mt-2 text-lg font-light mb-3 ">
                6.ENTIRE AGREEMENT
              </p>
              <p className="text-lg font-normal">
                The Agreement constitute the enetire understanding of the
                parties and supersedes all prior discussions and conversations
                of any kind
              </p>
              <CustomCheckbox
                data={data}
                label="I accept"
                name="agreement"
                checked={true}
                disabled
              />
            </div>
          </div>
          <CustomButton
             label={id ? "Update Contract" : "Generate Contract"}
            onClick={onArtworkSubmit}
          />
        </div>
      </div>
    </>
  );
};

export default ArtWork;
